import React from 'react';
import { motion } from 'framer-motion';
export const ChaptersSection = () => {
  const chapters = [{
    num: 1,
    title: 'Por qué no te están comprando',
    subtitle: 'La verdad incómoda'
  }, {
    num: 2,
    title: 'El mapa del dinero escondido',
    subtitle: 'Dónde están los clientes que sí pueden pagarte hoy'
  }, {
    num: 3,
    title: 'La ingeniería de la oferta irresistible',
    subtitle: 'Cómo empaquetar tu servicio para que sea imposible decir no'
  }, {
    num: 4,
    title: 'El sistema de reactivación de muertos',
    subtitle: 'Cómo despertar a los que te ignoraron o desaparecieron'
  }, {
    num: 5,
    title: 'El guion anti-objeciones de crisis',
    subtitle: 'Qué decir cuando te dicen "no tengo plata"'
  }, {
    num: 6,
    title: 'El plan de acción de 30 días',
    subtitle: 'Tu hoja de ruta para salir de la parálisis comercial'
  }];
  return <section className="py-24 bg-white border-y border-neutral-200" data-id="element-27">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-28">
        <div className="text-center mb-16" data-id="element-29">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-30">
            Adentro de CAJA DE COBRO vas a encontrar:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-31">
          {chapters.map((ch, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream rounded-xl p-6 sm:p-8 border border-neutral-200 hover:border-brand-400 hover:shadow-md transition-all group" data-id="element-32">
              <div className="flex items-center gap-4" data-id="element-33">
                <div className="flex-shrink-0 w-12 h-12 bg-white rounded-xl flex items-center justify-center border border-neutral-200 group-hover:bg-brand-600 group-hover:border-brand-600 transition-colors shadow-sm" data-id="element-34">
                  <span className="text-xl font-bold text-brand-600 group-hover:text-white" data-id="element-35">
                    0{ch.num}
                  </span>
                </div>
                <div data-id="element-36">
                  <h3 className="text-lg font-bold text-neutral-900 mb-1 flex items-center gap-2" data-id="element-37">
                    📖 {ch.title}
                  </h3>
                  <p className="text-brand-600 font-medium text-sm m-0" data-id="element-38">
                    {ch.subtitle}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};